export const question = [
    {
        id: 1,
        question:"Quantum of Finance",
        answer:"Need based subject to cost of the project and repaying capacity/income generation"
    },
    {
        id: 2,
        question:"Margin /Promoter’s contribution",
        answer:"Minimum 20%."
    },
    {
        id: 3,
        question:"Repayment Period",
        answer:"36 months to 60 months."
    },
    {
        id: 4,
        question:"Rate of Interest",
        answer:"BOZ policy rate plus margin"
    },
    {
        id: 5,
        question:"Security",
        answer:"Mortgage of property/ Debenture of immoveable and moveable assets/Liquid security etc"
    },
    {
        id: 6,
        question:"Processing Fee",
        answer:"2.5% to 3% upfront"
    },
]